import { FC, ReactElement } from 'react';

import { Grid } from '@mui/material';

interface CustomGridItem {
    item1: ReactElement;
    item2: ReactElement;
    item3?: ReactElement;
    columns?: 2 | 3;
}

export const CustomGridItem: FC<CustomGridItem> = ({ item1, item2, item3, columns = 3 }) => {
    let xsValue: number;
    switch (columns) {
        case 2:
            xsValue = 6;
            break;
        case 3:
            xsValue = 4;
            break;
        default:
            xsValue = 4;
    }

    return (
        <Grid container spacing={2} mb="8px">
            <Grid item xs={xsValue}>
                {item1}
            </Grid>
            <Grid item xs={xsValue} alignContent={'start'}>
                {item2}
            </Grid>
            {item3 && (
                <Grid item xs={xsValue}>
                    {item3}
                </Grid>
            )}
        </Grid>
    );
};
